import React, { useState } from 'react';

function App() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!name || !email) {
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      // Call Web3Forms directly from the frontend
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          access_key: '51eb5e36-14ad-4d7f-9010-137cc0cb1180',
          subject: `New Rendition AI Waitlist Signup: ${name}`,
          from_name: 'Rendition AI Waitlist',
          name: name,
          email: email,
          message: `Name: ${name}\nEmail: ${email}\n\nJoined the Rendition AI waitlist.`,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setSubmitStatus('success');
        setName('');
        setEmail('');
      } else {
        console.error('Error:', data);
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center px-6 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-20 right-20 w-96 h-96 bg-gradient-to-br from-blue-100/30 to-purple-100/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-20 w-80 h-80 bg-gradient-to-tr from-pink-100/20 to-orange-100/20 rounded-full blur-3xl"></div>

      <div className="max-w-2xl w-full space-y-12 py-16 relative z-10">
        {/* Company Name */}
        <div className="text-center space-y-6">
          <h1 className="text-6xl md:text-7xl font-light tracking-tight text-gray-900">
            Rendition AI
          </h1>

          {/* Tagline */}
          <p className="text-xl md:text-2xl font-light text-gray-600 leading-relaxed">
            Presentation automation for the modern professional
          </p>
        </div>

        {/* Waitlist Form - Glass Container */}
        <div className="max-w-xs mx-auto">
          <div className="backdrop-blur-xl bg-white/40 p-6 rounded-2xl border border-white/60 shadow-xl shadow-gray-200/50">
            <form onSubmit={handleSubmit} className="space-y-2.5">
              <div>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Name"
                  required
                  className="w-full px-3 py-2 text-sm border border-white/50 bg-white/60 backdrop-blur-sm focus:border-gray-400 focus:bg-white/80 focus:ring-1 focus:ring-gray-300 outline-none transition-all rounded-lg placeholder-gray-500"
                />
              </div>
              <div>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                  required
                  className="w-full px-3 py-2 text-sm border border-white/50 bg-white/60 backdrop-blur-sm focus:border-gray-400 focus:bg-white/80 focus:ring-1 focus:ring-gray-300 outline-none transition-all rounded-lg placeholder-gray-500"
                />
              </div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full px-3 py-2 bg-gray-900/90 backdrop-blur-sm text-white text-sm font-medium hover:bg-gray-900 transition-all rounded-lg disabled:bg-gray-400 disabled:cursor-not-allowed shadow-lg"
              >
                {isSubmitting ? 'Joining...' : 'Join Waitlist'}
              </button>
            </form>

            {/* Status Messages */}
            {submitStatus === 'success' && (
              <p className="mt-4 text-center text-sm text-green-600">
                Thank you for joining the waitlist!
              </p>
            )}
            {submitStatus === 'error' && (
              <p className="mt-4 text-center text-sm text-red-600">
                Something went wrong. Please try again.
              </p>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="text-center pt-12">
          <p className="text-sm font-semibold text-gray-400">
            Coming soon
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;
